import { useLoaderData, useParams } from "react-router";
import DocumentForm from "./DocumentForm";

export default function EditEmployeeDocument() {
  const document = useLoaderData();
  const { id } = useParams();
  return <DocumentForm document={document} returnPath={`/employees/${id}?tab=documents`} />;
}
